/**
 * Client-side deny-list for events that should never consume Sentry quota.
 * Patterns match exception messages and Sentry's wrapped non-Error rejections.
 *
 * Kept free of @sentry/browser so packages with separate installs can import it
 * without resolving Sentry types from spond-web-common-js.
 *
 * DIS-1679: browser-extension Distributor timeouts + WebView/extension bridges.
 */
export const IGNORED_ERRORS: RegExp[] = [
    /^Non-Error promise rejection captured with keys: data, headers, status$/,
    /The user aborted a request\./,
    /^Error: Fetch is aborted$/,
    /^AbortError: The user aborted a request\.$/,
    // LanguageTool-style extension: "Request timeout *Distributor.getValue"
    /Request timeout \S*Distributor(?:\.getValue)?/,
    /Request timeout (?:getDictionariesByLanguageId|isDictateAvailable|isPredictionAvailable|isMathOcrAvailable|DefineExpirationForLanguagePacks(?:\.getValue)?)/,
    // Facebook/Android IAB WebView bridge
    /Error invoking postMessage: Java object is gone/,
    // Browser extension messaging
    /Invalid call to runtime\.sendMessage\(\)\. Tab not found/,
];
